import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoutAccount from '../LogoutAccount';
import logoColor from "../../assets/galaxy-labs-logo.png";

const Header = () => {
  const location = useLocation();
  const [name] = useState(localStorage.getItem('fullNameAdmin'));
  const [showLogout, setShowLogout] = useState(false);

  const signOutHandler = (e) => {
    e.preventDefault();
    setShowLogout(true);
  };

  const handleClose = () => {
    setShowLogout(false);
  };

  const currentPath = location.pathname;

  return (
    <main id="main" className="main mt-0 pt-0 px-0 pb-0 sticky-top">
      <header className="header d-flex justify-content-between align-items-center p-3 bg-white shadow-sm">
        <div className="d-flex align-items-center">
          {/* Hamburger only on mobile */}
          <button
            className="btn d-lg-none me-2 mobile-pr-zero"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileSidebar"
            aria-controls="mobileSidebar"
          >
            <i className="bi bi-filter-left toggle-sidebar-btn"></i>
          </button>
          <img src={logoColor} alt="Logo" height="40" />
        </div>

        {showLogout && <LogoutAccount showLogout={showLogout} handleClose={handleClose} />}

        <nav className="header-nav">
          <ul className="d-flex align-items-center mb-0">
            <li className="nav-item dropdown pe-3">
              <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                <span className="d-none d-md-block dropdown-toggle ps-2">{name || "Admin"}</span>
              </a>
              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                <li className="dropdown-header">
                  <h6>{name}</h6>
                  <span>Admin</span>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <a className="dropdown-item d-flex align-items-center" onClick={signOutHandler}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Sign Out</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>

      {/* Offcanvas sidebar for mobile */}
      <div className="offcanvas offcanvas-start d-lg-none" tabIndex="-1" id="mobileSidebar">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Menu</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="nav flex-column sidebar-nav">
             <li>
              <Link className={`nav-link ${currentPath === "/manage-categories" ? "" : "collapsed"}`} to="/manage-categories">
                <i className="bi bi-grid-1x2-fill me-2"></i>Manage Categories
              </Link>
            </li>
            <li>
              <Link className={`nav-link ${currentPath === "/manage-products" ? "" : "collapsed"}`} to="/manage-products">
                <i className="bi bi-inboxes-fill me-2"></i>Manage Products
              </Link>
            </li>
            <></>
              <li>
              <Link className={`nav-link ${currentPath === "/social-links" ? "" : "collapsed"}`} to="/social-links">
                <i className="bi bi-image-fill me-2"></i>Social Links
              </Link>
            </li>
            
            
            
            
            
            
            
            
            <li>
              <Link className={`nav-link ${currentPath === "/eligibility-shopping" ? "" : "collapsed"}`} to="/eligibility-shopping">
                <i className="bi bi-bag-check-fill me-2"></i>Eligibility Shopping
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Header;
